import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrl: './maps.component.scss'
})

export class MapsComponent {
  @Input() order_location!: string;
  center: google.maps.LatLngLiteral = { lat: 30.0444, lng: 31.2357 }; // القاهرة كبداية
  markerPosition: google.maps.LatLngLiteral | null = null;
  markerOptions: google.maps.MarkerOptions = {
    draggable: true,
    icon: {
      url: 'assets/e-commerce/icons/54.webp', // ضع مسار الصورة هنا
      scaledSize: new google.maps.Size(50, 50), // حجم الأيقونة
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 50) // تثبيت الماركر من الأسفل
    }
  };

  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
    draggable: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    gestureHandling: 'none',

    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,

    styles: [
      {
        elementType: 'geometry',
        stylers: [{ color: '#f8f5f1' }]
      },
      {
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }]
      },
      {
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6f5a43' }]
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#fffaf5' }]
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#eadfce' }]
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#b7a692' }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#f3ece3' }]
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#8b7763' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#eef7ee' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6d8b6d' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#f0d7ab' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#e7c58f' }]
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#7b6857' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#fc930b' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#d97d08' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#5c4632' }]
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ color: '#efe7dc' }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#bfe3f7' }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#a84e4e' }]
      }
    ]
  };
  ngOnInit() {
    if (this.order_location) {
      this.setLocationFromLink(this.order_location);
    }
  }
  setLocationFromLink(link: string) {
    try {
      // الرابط بيبقى كده: https://www.google.com/maps?q=30.04248,31.36533
      const url = new URL(link);
      const coords = url.searchParams.get("q"); // 30.04248,31.36533

      if (coords) {
        const [lat, lng] = coords.split(",").map(Number);

        this.center = { lat, lng };
        this.markerPosition = { lat, lng };
      }
    } catch (error) {
      console.error("❌ الرابط غير صالح:", link);
    }
  }
}
